export default {
  social(state, data) {
    state.social.list = data;
  },
};
